// import request from '@/common/network/JavaRequest'
import request from '@/common/network/JavaRequest2'

export class JavaHttp {
  static putData(url: string, data: any = null) {
    return request({
      url: url,
      method: 'put',
      data: data
    })
  }
  static postData(url: string, data: any) {
    return request({
      url: url,
      method: 'post',
      data
    })
  }

  static getData(url: string, data: any = null) {
    if (data && data.page) {
      data.pageNum = data.page
      delete data.page
    }
    return request({
      url: url,
      method: 'get',
      params: data
    })
  }

  static deleteData(url: string) {
    return request({
      url: url,
      method: 'delete'
    })
  }

  static postDataCallback(url: string, data: any, callback: Function) {
    request({
      url: url,
      method: 'post',
      data
    })
      .then((res: any) => {
        callback(true, res)
      })
      .catch((err: any) => {
        callback(false, { code: 0, message: err || '服务器异常' })
      })
  }
}

export default JavaHttp
